export interface Timeline {
  created?: string;
  title?: string;
  author?: string;
  content?: string;

  [key: string]: string;
}
